import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      fontFamily: 'Roboto',
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      maxHeight: '350px',
    },
    divider: {
      width: '100%',
      height: '1px',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
    remainingWithdrawalAmount: {
      color: 'rgba(41, 121, 255, 0.87)',
      fontWeight: 700,
      fontSize: '18px',
    }
  }
))
